import { render, staticRenderFns } from "./UserAdminSidebar.vue?vue&type=template&id=3b48f011&scoped=true"
import script from "./UserAdminSidebar.vue?vue&type=script&lang=js"
export * from "./UserAdminSidebar.vue?vue&type=script&lang=js"
import style0 from "./UserAdminSidebar.vue?vue&type=style&index=0&id=3b48f011&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b48f011",
  null
  
)

export default component.exports